import { Box, Typography } from "@mui/material";

type FindingTitleCellProps = {
  value: string | null | undefined;
};

export function FindingTitleCell({ value }: FindingTitleCellProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontWeight: 500,
          fontSize: "14px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {value || "-"}
      </Typography>
    </Box>
  );
}
